"use strict";function punchModePicker$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.punchModePicker$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.ATMBle.punchModePicker";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"5.0.7"},_a[ddSdk_1.ENV_ENUM.android]={vs:"5.0.7"},_a)),exports.punchModePicker$=punchModePicker$,exports.default=punchModePicker$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/ATMBle/punchModePicker.js
// module id = 904
// module chunks = 106